import React from "react";

const About = () => {
    return (
        <section id="about" className="about-section py-5">
            <div className="container">
                <div className="row justify-content-center mb-4">
                    <div className="col-12 col-lg-10 text-center">
                        <div className="about-logo mb-3 mx-auto">
                            <img src="/img/lotusbluete_logo.jpeg" alt="Lotusblüte Logo" width={64} height={64} style={{borderRadius:'50%', boxShadow:'0 2px 10px 0 rgba(99,102,241,0.10)'}} />
                        </div>
                        <h2 className="h2 mb-2 fw-bold">Lotusblüte Gebäudereinigung</h2>
                        <p className="about-claim mb-3">Sauberkeit, auf die Sie sich verlassen können.</p>
                    </div>
                </div>
                <div className="row g-4 mb-4 justify-content-center">
                    <div className="col-6 col-md-3">
                        <div className="about-feature-card text-center p-3 h-100">
                            <i className="fas fa-leaf fa-2x text-success mb-2"></i>
                            <div className="fw-semibold">Umweltbewusst</div>
                            <div className="about-feature-desc">Nachhaltige Reinigungsmittel &amp; Verfahren</div>
                        </div>
                    </div>
                    <div className="col-6 col-md-3">
                        <div className="about-feature-card text-center p-3 h-100">
                            <i className="fas fa-user-shield fa-2x" style={{color: 'mediumpurple', marginBottom: '0.5rem'}}></i>
                            <div className="fw-semibold">Zuverlässig</div>
                            <div className="about-feature-desc">Pünktlich, diskret und vertrauensvoll</div>
                        </div>
                    </div>
                    <div className="col-6 col-md-3">
                        <div className="about-feature-card text-center p-3 h-100">
                            <i className="fas fa-broom fa-2x text-warning mb-2"></i>
                            <div className="fw-semibold">Gründlich</div>
                            <div className="about-feature-desc">Sichtbare Sauberkeit &amp; Wohlfühlräume</div>
                        </div>
                    </div>
                    <div className="col-6 col-md-3">
                        <div className="about-feature-card text-center p-3 h-100">
                            <i className="fas fa-euro-sign fa-2x" style={{color: '#7d5bbe', marginBottom: '0.5rem'}}></i>
                            <div className="fw-semibold">Fair</div>
                            <div className="about-feature-desc">Transparente Preise &amp; Beratung</div>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-9">
                        <div className="about-desc text-center px-2 px-md-4 mb-4">
                            <p className="lead mb-2">
                                Wir sind Ihr Partner für professionelle Gebäudereinigung in Ihrer Region – von Haushalten über Büros bis zu Entrümpelungen. Unser Team arbeitet mit Herz, Verstand und modernen Methoden, damit Sie sich rundum wohlfühlen können.
                            </p>
                            <p className="mb-0 small text-muted">
                                Gegründet von Oguzhan Cosgun und Kai Andre Grall. Vertrauen Sie auf Kompetenz, Erfahrung und ein faires Preis-Leistungs-Verhältnis.
                            </p>
                        </div>
                        <div className="text-center">
                            <a href="#contact" className="btn contact-btn about-cta">Jetzt anfragen</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;


// WEBPACK FOOTER //
// ./src/components/About.js